import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=496aeb56&scoped=true"
import script from "./payFail.vue?vue&type=script&lang=js"
export * from "./payFail.vue?vue&type=script&lang=js"
import style0 from "./payFail.vue?vue&type=style&index=0&id=496aeb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496aeb56",
  null
  
)

export default component.exports